import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import FinalCTA from "@/components/FinalCTA";
import Seo from "@/components/Seo";
import { Icon } from "@/components/Icon";
import { SERVICES, IMAGES } from "@/lib/content";

const media = [IMAGES.serviceBookkeeping, IMAGES.servicePayroll, IMAGES.serviceConsultancy];

const Services = () => {
  return (
    <div data-testid="services-page">
      <Seo
        title="Our Services — Bookkeeping, Payroll & Consultancy"
        description="Professional bookkeeping, payroll and consultancy for Aruban businesses — accurate records in QuickBooks Online, reliable payroll and practical financial guidance, with fixed monthly fees."
        path="/services"
        image="/images/services/consultancy.jpg"
      />
      <PageHeader
        overline="Our Services"
        title="Accounting, bookkeeping, payroll and consultancy"
        subtitle="Professional, dependable services delivered with personal attention and fixed, predictable monthly fees."
      />

      {SERVICES.map((s, i) => {
        const imageLeft = i % 2 === 0;
        return (
          <section
            key={s.title}
            data-testid={`services-detail-${s.title.toLowerCase()}`}
            className={i % 2 === 0 ? "bg-white" : "bg-[#F5F6FB]"}
          >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 lg:py-28">
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                <Reveal
                  className={`lg:col-span-6 ${
                    imageLeft ? "order-1" : "order-1 lg:order-2"
                  }`}
                >
                  <div className="rounded-lg overflow-hidden shadow-[0_20px_50px_-24px_rgba(36,59,99,0.3)] border border-[#2A2E7A]/5">
                    <img
                      src={media[i]}
                      alt={`${s.title} services`}
                      className="w-full h-[380px] lg:h-[460px] object-cover"
                      loading="lazy"
                    />
                  </div>
                </Reveal>

                <Reveal
                  delay={0.1}
                  className={`lg:col-span-6 ${
                    imageLeft ? "order-2" : "order-2 lg:order-1"
                  }`}
                >
                  <span className="flex h-14 w-14 items-center justify-center rounded-md bg-[#2A2E7A]">
                    <Icon name={s.icon} className="h-7 w-7 text-white" />
                  </span>
                  <h2 className="mt-6 font-heading text-3xl sm:text-4xl font-bold tracking-[-0.02em] text-[#2A2E7A] leading-[1.15]">
                    {s.title}
                  </h2>
                  <p className="mt-5 text-lg text-[#51607A] leading-relaxed">{s.summary}</p>
                  <ul className="mt-8 space-y-3">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-start gap-3 text-base text-[#2A2E7A]">
                        <Icon
                          name="Check"
                          className="h-5 w-5 text-[#4B5CAB] mt-0.5 shrink-0"
                          strokeWidth={2.25}
                        />
                        <span>{p}</span>
                      </li>
                    ))}
                  </ul>
                </Reveal>
              </div>
            </div>
          </section>
        );
      })}

      <FinalCTA />
    </div>
  );
};

export default Services;
